export default {
  nutritionSurveySchema: (state, getters) => {
    if (state.nutritionSurveySchema) {
      return state.nutritionSurveySchema
    } else {
      return null
    }
  },
  surveyStep (state, getters) {
    return state.surveyStep
  }
}



// WEBPACK FOOTER //
// ./src/app/store/surveys/getters.js